<template>
  <div :class="alertClasses" class="base-alert px-3">
    <img
      v-if="icon && type === 'warning'"
      :class="iconClass"
      class="alert-icon"
      :src="alertIconSrc"
      alt="Ícone"
      style="overflow: visible"
    />
    <v-icon v-else-if="icon" :class="iconClass" class="alert-icon">{{
      icon
    }}</v-icon>
    <div class="alert-content">
      <p class="alert-title mb-0">{{ title }}</p>
      <p class="alert-description mb-0">{{ description }}</p>
    </div>
    <div v-if="$slots.default" class="alert-button ml-auto">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseAlert',
  data: () => ({
    alertIconsPath: {
      warning: require('@/assets/snackbar/icons/alert-solid.svg'),
    },
  }),
  props: {
    type: {
      type: String,
      default: 'informative',
      validator: (value) =>
        ['informative', 'warning', 'danger', 'success', 'trial'].includes(
          value
        ),
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  computed: {
    alertClasses() {
      switch (this.type) {
        case 'warning':
          return 'alert-warning'
        case 'danger':
          return 'alert-danger'
        case 'success':
          return 'alert-success'
        case 'trial':
          return 'alert-trial'
        default:
          return 'alert-informative'
      }
    },
    icon() {
      switch (this.type) {
        case 'warning':
          return 'mdi-alert'
        case 'danger':
          return 'mdi-close-octagon'
        case 'success':
          return 'mdi-check-circle'
        case 'trial':
        case 'informative':
          return 'mdi-information'
        default:
          return ''
      }
    },
    iconClass() {
      return `${this.type}-icon`
    },
    alertIconSrc() {
      return this.alertIconsPath[this.type]
    },
  },
}
</script>

<style lang="scss" scoped>
.base-alert {
  display: flex;
  padding: var(--spacing-03, 8px) var(--spacing-04, 12px);
  align-items: center;
  gap: var(--spacing-04, 12px);
  align-self: stretch;
  border-radius: var(--spacing-02, 4px);
}

.alert-icon {
  font-size: 24px;
}

.informative-icon {
  color: varFigma(brand-60-base);
}

.warning-icon {
  color: varFigma(feedback-warning);
}

.danger-icon {
  color: varFigma(feedback-danger);
}

.success-icon {
  color: varFigma(feedback-success);
}

.trial-icon {
  color: varFigma(trial-trial);
}

.alert-content {
  display: flex;
  flex-direction: column;
}

.alert-title {
  color: varFigma(neutral-20-dark) !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
}

.alert-description {
  color: varFigma(neutral-40-light);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.alert-informative {
  border: 1px solid varFigma(brand-90);
  background-color: varFigma(neutral-100-white);
}

.alert-warning {
  border: 1px solid varFigma(feedback-warning);
  background-color: varFigma(feedback-warning-background);
}

.alert-danger {
  border: 1px solid varFigma(feedback-danger);
  background-color: varFigma(feedback-danger-background);
}

.alert-success {
  border: 1px solid varFigma(feedback-success);
  background-color: varFigma(feedback-success-background);
}

.alert-trial {
  border: 1px solid varFigma(trial-trial);
  background-color: varFigma(trial-background);
}
</style>
